import { i18n } from '@ecg-marktplaats/js-react-i18n';
import dateLocale from 'date-fns/locale/nl';
import translation from '../../../../locales/nl-BE/translation.json';
import common from '../../../../locales/nl-BE/common.json';
import reviewsDialogUi from '@ecg-marktplaats/reviews-dialog-ui/locales/nl-BE.json';

export default i18n.init({
  lng: 'nl-BE',
  translation,
  dateLocale,
  translations: {
    translation,
    common,
    reviewsDialogUi,
  },
});
